module.exports = __webpack_public_path__ + "static/media/flash.73bb1c70.svg";